// A length of time in milliseconds as m:ss, or h:mm:ss once it runs past an hour
function durationToString(duration) {
    if (duration == null) return "—";
    const totalSeconds = Math.round(duration / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds / 60) % 60;
    const seconds = totalSeconds % 60;
    const pad = value => ("0" + value).slice(-2);
    return hours === 0 ? `${minutes}:${pad(seconds)}` : `${hours}:${pad(minutes)}:${pad(seconds)}`;
}

export default durationToString;
